module.exports = __webpack_public_path__ + "static/media/drop_arrow.2b1f6bf0.svg";